import { Box, Skeleton } from '@mui/material'
import { FC } from 'react'

interface ITableListSkeletonProps {
  rows?: number
  rowHeight?: number
  showHeader?: boolean
}

export const TableListSkeleton: FC<ITableListSkeletonProps> = ({
  rows = 8,
  rowHeight = 56,
  showHeader = true,
}) => (
  <Box sx={{ width: '100%', py: 0.5 }}>
    {showHeader && (
      <Skeleton variant="rounded" height={42} sx={{ mb: 1, borderRadius: 1 }} />
    )}
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        height={rowHeight}
        sx={{ mb: 0.75, borderRadius: 1 }}
      />
    ))}
  </Box>
)
